import React from 'react';
import { NumericFormat } from 'react-number-format';
import { connect } from 'react-redux';

import { changeFieldProperty, setFieldError } from 'apps/auth/actions/formAction';
import InputBase from 'apps/auth/components/form-multi/InputBase';
import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { ERROR_MESSAGE, VERIFICATION_AMOUNT } from 'apps/auth/constants/fieldsName';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';
import { useNumberSeparators } from 'apps/auth/hooks/useNumberSeparators';

const AmountVerificationInput = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { thousandSeparator, decimalSeparator } = useNumberSeparators(lang, country);

    const handlerChange = (value) => {
        const floatValue = value.floatValue;
        validationAndUpdateValue(props.formName, floatValue, props.field, props.changeFormField).then(() => {
            if (floatValue) {
                validateVerificationAmount(floatValue);
            } else if (!floatValue && props.field?.errorMessage) {
                props.changeFieldProperty(props.formName, field.name, ERROR_MESSAGE, null);
            }
        });
    };

    const validateVerificationAmount = (value) => {
        const min = props.minAmount?.amount;
        const max = props.maxAmount?.amount;
        if (value < min || value > max) {
            props.setFieldError(props.formName, VERIFICATION_AMOUNT, props.field?.checkRegexpError);
        }
    };

    const handlerBlur = (e) => {
        const field = props.field;
        const floatValue = field.value;
        if (!props.field.value) {
            validationAndUpdateValue(props.formName, floatValue, field, props.changeFormField);
        }
        if (props.onBlur) {
            props.onBlur(e);
        }
    };

    const handlerFocus = (e) => {
        if (props.onFocus) {
            props.onFocus(e);
        }
    };

    const field = props.field;

    return (
        <NumericFormat
            id={field.name}
            maxLength="14"
            name={field.canonicalPath ? field.canonicalPath : field.name}
            value={field.value || ''}
            type={field.type}
            readOnly={props.readOnly}
            className={props.isNewInput ? null : `field field-duo${props.classNameError ? ' color-red' : ''}`}
            autoComplete="off"
            allowNegative={false}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            fixedDecimalScale={true}
            decimalScale={2}
            onValueChange={handlerChange}
            onBlur={handlerBlur}
            onFocus={handlerFocus}
        />
    );
};

const AmountField = InputBase(AmountVerificationInput, false);
export default connect(null, { changeFieldProperty, setFieldError })(AmountField);
